import { FormattedMessage } from 'react-intl';

function Forbidden(props) {
  // Get window location to pass to sidebar

  return (
    <div>
      <FormattedMessage id="403_FORBIDDEN" values ={{newline: <br/>}}/>
    </div>
  )
}

export default Forbidden
